import { CheckIcon } from 'ck-assets';
import { Icon } from './Icon/Icon';

type TargetAudienceCountProps = {
  count: string | number;
};

/**
 * A label visualizing the count of target audience members
 *
 * @param count the number of people in the selected target group
 */
export const TargetAudienceCount = ({ count }: TargetAudienceCountProps) => {
  const correctGrammarText = count === 1 ? 'person' : 'personer';

  return (
    <div className='flex flex-1 items-center gap-3 rounded-md border border-blue-400 bg-blue-50'>
      <div className='p-3 text-blue-500'>
        <Icon src={CheckIcon} size={6} />
      </div>
      <p className='text-sm text-neutral-800'>
        Din valda målgrupp innehåller <b>{count}</b> {correctGrammarText}.
      </p>
    </div>
  );
};
